
import { User } from "../../../../../domain/entities/entities";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { computed, ComputedRef, ref } from "@vue/reactivity";
import { defineComponent, onMounted, Ref } from "vue";
import { dispatchError } from "../../../utils/error_handling";
import ModalTerm from "../../landingpage/ModalTerm.vue";
import { isDecolaTemplate } from "../../mixins";

/** Todo: document this class. */
class UserInput {
  public loginMask: string = "";
  public loginFormatted: string = "";
  public password: string = "";

  constructor(mask: string = "", login: string = "", password: string = "") {
    this.loginMask = mask;
    this.loginFormatted = login;
    this.password = password;
  }
}

export default defineComponent({
  components: { ModalTerm },
  setup() {
    onMounted(() => {
      setTimeout(() => {
        document?.getElementById("login-document")?.focus();
      }, 250);
    });

    /** Instance of the vuex store. */
    const store = useStore();

    /** Instance of a router. */
    const router = useRouter();

    const route = useRoute();

    /** Todo: document this. */
    const userInput: Ref<UserInput> = ref(new UserInput());

    const showRegisterButton = isDecolaTemplate();

    /** Tells whether the password is visible or not. */
    const isPasswordVisible: ComputedRef<boolean> = computed(() => {
      return store.getters["authentication_module/isPasswordVisible"];
    });

    const showPassword = () => {
      store.dispatch("authentication_module/showPassword");
    };

    const hidePassword = () => {
      store.dispatch("authentication_module/hidePassword");
    };

    const togglePassword = () => {
      isPasswordVisible.value ? hidePassword() : showPassword();
    };

    const maskCPF = (event: Event): void => {
      const input = event.target as HTMLInputElement;

      if (input.value.includes("@")) {
        return;
      }

      userInput.value.loginMask = maskedCPF(input.value).trim();
    };

    const unmaskCPF = (event: Event): void => {
      const input = event.target as HTMLInputElement;

      if (input.value.includes("@")) {
        return;
      }

      userInput.value.loginMask = input.value.replace(/(\.|\/|\-)/g, "").trim();
    };

    const maskedCPF = (value: string): string => {
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
    };

    /** Requests the login and redirects the user to the dashboard.
     * If it's the user's first login a password redefinition modal is called before the navigation. */
    const login = async (): Promise<void> => {
      userInput.value.loginFormatted = userInput.value.loginMask.includes("@")
        ? userInput.value.loginMask.trim()
        : userInput.value.loginMask
          .replaceAll("-", "")
          .replaceAll(".", "")
          .trim();

      const credentials = new User(
        userInput.value.loginFormatted,
        userInput.value.password
      );
      try {
        /** Log the user in. */
        await store.dispatch("authentication_module/login", credentials);

        /** Get the logged user. */
        await store.dispatch("userProfile_module/loadUser");
        const user: User = store.getters["userProfile_module/user"];

        /** If the user is imported and still hasn't created their new password. */
        if (user.isImported && !user.passwordModifiedAt) {
          /** Open the modal to change the password. */
          await router.push({
            name: "home",
            query: {
              firstLogin: "create-new-credentials"
            }
          });
        } else if (user.needAcceptNewTerm) {
          if (route.query.redirect) {
            /** Open the modal to change the password. */
            await router.push({
              name: "home",
              query: {
                acceptTerm: "true",
                redirect: route.query.redirect
              }
            });
          } else {
            /** Open the modal to change the password. */
            await router.push({
              name: "home",
              query: {
                acceptTerm: "true"
              }
            });
          }
        } else {
          /** Redirect them to the app's dashboard. */
          if (route.query.redirect) {
            await router.push(route.query.redirect as string);
          } else {
            await router.push({ name: "dashboard" });
          }
        }
      } catch (e) {
        await dispatchError(e);
      }
}

    return {
      showRegisterButton,
      isPasswordVisible,
      userInput,
      maskCPF,
      unmaskCPF,
      login,
      showPassword,
      hidePassword,
      togglePassword,
      isDecolaTemplate
    };
  }
});
